/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Team_TextInputs */



/**
* | output |
* | --- |
* | "The people who run AWP Marine day to day." |
*
* @param {About_Team_TextInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const about_team_text = /** @type {((inputs?: About_Team_TextInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Team_TextInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return /** @type {LocalizedString} */ ("负责 AWP Marine 日常运营的团队成员。")
	return /** @type {LocalizedString} */ ("The people who run AWP Marine day to day.")
});